export const config = {
  API_URL: process.env.VUE_APP_API_URL,
  SOCIAL_AUTH_REDIRECT_URL: process.env.VUE_APP_SOCIAL_AUTH_REDIRECT_URL,
  S3_BUCKET: process.env.VUE_APP_S3_BUCKET,
  ASL_ASSETS: process.env.VUE_APP_ASL_ASSETS
};
